import { useParams } from "react-router-dom"

import { PointSelectListener } from "@l2r-front/l2r-common"

import { useHorizontalSign } from "../../hooks/queries/horizontalSigning/useHorizontalSigns"

export function HorizontalSignSelectListener() {

    const { signId } = useParams()

    const { data: signFeature } = useHorizontalSign(signId, { as_geojson: true })

    return <PointSelectListener pointFeature={signFeature} />
}
